/**
 * Make flat copy of any structure. Usually used to copy structure to avoid mutability for this structure.
 *
 * @param {unknown} structure Structure to be cloned.
 * @returns {unknown}
 */
export function pureStructure(structure) {
    if (!structure) {
        return structure;
    }
    if (structure === Infinity) {
        return Infinity;
    }
    return JSON.parse(JSON.stringify(structure));
}
